import { render, staticRenderFns } from "./exchange-results.pug?vue&type=template&id=fe93e470&scoped=true&lang=pug&external"
import script from "./exchange-results.js?vue&type=script&lang=js&external"
export * from "./exchange-results.js?vue&type=script&lang=js&external"
import style0 from "./exchange-results.scss?vue&type=style&index=0&id=fe93e470&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe93e470",
  null
  
)

export default component.exports